import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { EdiStandardsListQuery } from '../gql-types.generated';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const QUERY_EDI_STANDARDS_LIST = gql`
    query ediStandardsList {
        ediStandards {
            nodes {
                name
                description
                id
            }
        }
    }
`;

export const queryEdiStandardList = async (client: ApolloClient<NormalizedCacheObject>) => {
    
    const { data, errors } = await client.query<EdiStandardsListQuery>({
        query: QUERY_EDI_STANDARDS_LIST,
    });

    if (errors && errors.length > 0) {
        errors.forEach(error => {
            // Log error details in the console.
            console.error(error);
        });
        // Friendly error to the user.
        throw new Error('An error has occurred during the query.');
    }

    return data?.ediStandards?.nodes;
};